import { createSelector } from '@ngrx/store';
import { JobsByCompanyInterface } from './jobs-company.state';
import { getJobsByCompanyNumber } from '../../store/store.selectors';

export const getJobsByCompany = createSelector(
  getJobsByCompanyNumber,
  (state: JobsByCompanyInterface) => state.jobs
);
